import i from "./index822.js";
import e from "./index703.js";
import f from "./index809.js";
import n from "./index855.js";
import a from "./index908.js";
import p from "./index914.js";
import s from "./index856.js";
var u = 1, A = 2;
function y(r, o) {
  return n(r) && a(o) ? p(s(r), o) : function(m) {
    var t = e(m, r);
    return t === void 0 && t === o ? f(m, r) : i(o, t, u | A);
  };
}
export {
  y as default
};
